module.exports = __webpack_public_path__ + "static/rajesh-4ce2d26c459cd979bb9d95771e1f9d10.png";